// Chatbot integration helpers
// Centralizes token sync for the embedded chatbot across the app.

export function updateChatbotToken(accessToken) {
  try {
    const args = {
      insyncEnv: window.__tpc_env || 'staging',
      eventType: 'sessionDataUpdated',
      data: { contextParams: { brandUserSessionToken: accessToken } },
    };
     
    console.log('%c%s window.insyncSetChatEnv.sendSessionData', 'color: #ea00ff', JSON.stringify(args));
     
    console.debug('ChatBot update token with args:' + JSON.stringify(args));

    if (window?.insyncSetChatEnv?.sendSessionData) {
      window.insyncSetChatEnv.sendSessionData(args);
    }

    window.insyncChatbotConfig = {
      insyncContextParams: { brandUserSessionToken: accessToken },
    };
  } catch (error) {
     
    console.log('Update ChatBot with token failed:', error);
  }
}

export function clearChatbotToken() {
  try {
    if (window?.insyncSetChatEnv?.sendSessionData) {
      window.insyncSetChatEnv.sendSessionData({
        insyncEnv: window.__tpc_env || 'staging',
        eventType: 'sessionDataUpdated',
        data: { contextParams: { brandUserSessionToken: '' } },
      });
    }
    if (window.insyncChatbotConfig?.insyncContextParams) {
      window.insyncChatbotConfig.insyncContextParams.brandUserSessionToken = '';
    }
  } catch (error) {
     
    console.log('Clear ChatBot token failed:', error);
  }
}
